import '../styles/About.css';
function About() {
  return (
    <div id='about' class='container-fluid row align-items-start'>
      <div class='col'>
        <div class='a'>TECH STACK</div>
        <div class='b'>MERN STACK</div>

        <div class='b'>ETHEREUM</div>
        <div class='b'>SOLIDITY & WEB3.JS</div>
        <div class='b'>ADOBE PHOTOSHOP</div>
      </div>
      <div class='col'>
        <div class='a'>INTERESTS & RECOGNITION</div>
        <div class='b'>
          <h3>TECHNICAL LEAD (@DSC JIIT 128)</h3>
        </div>
        <div class='b'>HACKATHONS</div>
        <div class='b'>FITNESS</div>
        <div class='b'>WRITER</div>
        <div class='b'>SPORTS</div>
      </div>
      <div class='col a'>
        <div class='a'>ROLES</div>
        <div class='b'>FULL STACK DEVELOPER</div>
        <div class='b'>BLOCKCHAIN DEVELOPER</div>
        <div class='b'>GRAPHIC DESIGNER</div>
      </div>
    </div>
  );
}

export default About;
